<app-pagination-header
  [label]="label"
  [paging]="paging"
  (pageSizeChange)="pageSizeChange.emit($event)" />

@if (!loading) {
  <app-encounter-type-eligibility-summary-list
    [encounterTypeEligibilitySummaries]="encounterTypeEligibilitySummaries" />
} @else {
  <mat-spinner diameter="30" />
}

<app-pagination [paging]="paging" (pageChange)="pageChange.emit($event)" />
